import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import pl from './locales/pl.json';

// Language detection and persistence
const getStoredLanguage = (): string => {
  const stored = localStorage.getItem('clp-app-language');
  if (stored && ['en', 'pl'].includes(stored)) {
    return stored;
  }
  
  // Fallback to browser language
  const browserLang = navigator.language.split('-')[0];
  return ['en', 'pl'].includes(browserLang) ? browserLang : 'en';
};

const setStoredLanguage = (language: string): void => {
  localStorage.setItem('clp-app-language', language);
};

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pl: { translation: pl },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    // Save language changes to localStorage
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  setStoredLanguage(lng);
});

// Temporary: ensure new resource usage keys exist in Polish locale even if the JSON file lacks them
i18n.addResourceBundle(
  'pl',
  'translation',
  {
    organizationSetup: {
      resourcesUsageSectionTitle: 'Zużycie zasobów',
      resourcesUsageEmpty: 'Brak danych o zużyciu zasobów dla tej organizacji.',
      resourcesUsageFetchError: 'Nie udało się pobrać zużycia zasobów.',
    },
    resources: {
      PRODUCT: 'Produkty',
    },
    errors: {
      noCapacity: 'Wyczerpano limit dla tej operacji w ramach aktualnego planu Twojej organizacji. Skontaktuj się z administratorem organizacji w celu zwiększenia limitu.',
    },
  },
  true,
  true,
);

// Ensure EN also has the key (in case locales are out of sync during dev)
i18n.addResourceBundle(
  'en',
  'translation',
  {
    errors: {
      noCapacity: "You have reached the limit for this operation under your organization's current plan. Please contact your organization administrator to increase the limit.",
    },
  },
  true,
  true,
);

export default i18n;
